import { createHash, randomBytes } from 'crypto';

export const createCodeVerifier = () =>
  randomBytes(32)
    .toString('base64')
    .replace(/[^a-zA-Z0-9]/g, '')
    .substring(0, 128);

export const createCodeChallenge = (verifier: string): string => {
  return createHash('sha256').update(verifier).digest('base64url');
};

export const generateState = (): string => {
  return randomBytes(16).toString('base64url');
};
